<template @keyup.esc="closeEverything">
    <div id="data-list-thumb-view" class="data-list-container">
        <vs-table ref="table" :max-items="20" pagination search :data="deliverers">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center">
                    <!-- ADD NEW -->
                    <div
                            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                            @click="addNewData"
                    >
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                        <span class="ml-2 text-base text-primary">Bezorger toevoegen</span>
                    </div>
                    <div
                            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                            @click="openSmsPopup"
                    >
                        <span class="ml-2 text-base text-primary">Bulk SMS</span>
                    </div>
                    <div
                            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                            @click="openNotificationPopup"
                    >
                        <span class="ml-2 text-base text-primary">Bulk Notificatie</span>
                    </div>
                </div>
                <!-- ITEMS PER PAGE -->
                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-model="trashed">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ trashed ? "Uit dienst" : "In dienst"}}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                    </div>
                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="trashed = false">
                            <span>In dienst</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="trashed = true">
                            <span>Ontslagen/non actief</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="name">Naam</vs-th>
                <vs-th sort-key="phone_number">Telefoonnummer</vs-th>
                <vs-th sort-key="address">Adres</vs-th>
                <vs-th sort-key="drivers_licence">Rijbewijs</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr
                        :data="deliveryDriver"
                        :key="index"
                        v-for="(deliveryDriver, index) in data"
                        @click.native="openPopup(deliveryDriver)"
                >
                    <vs-td>
                        <p class="deliverer-name">{{ deliveryDriver.name }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="deliverer-phone_number">{{ deliveryDriver.phone_number }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="deliverer-address">{{ address(deliveryDriver) }}</p>
                    </vs-td>
                    <vs-td>
                        <p class="deliverer-license">{{ deliveryDriver.drivers_licence }}</p>
                    </vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>

        <ht-deliverer-popup></ht-deliverer-popup>
        <ht-sms-popup></ht-sms-popup>
        <ht-clothing-popup></ht-clothing-popup>
        <ht-notification-popup></ht-notification-popup>
    </div>
</template>

<script>
    import DelivererPopup from "./Components/DelivererPopup";
    import ClothingPopup from "./Components/NewClothingPopup";
    import SmsPopup from "./Components/SmsPopup";
    import NotificationPopup from "./Components/NotificationPopup";

    export default {
        components: {
            "ht-deliverer-popup": DelivererPopup,
            "ht-sms-popup": SmsPopup,
            "ht-clothing-popup": ClothingPopup,
            "ht-notification-popup": NotificationPopup,
        },
        data() {
            return {
                selected: [],
                deliverers: [],
                itemsPerPage: 20,
                isMounted: false,
                addNewDataSidebar: false,
                sidebarData: {},
                total: 20,
                activeDeliverer: null,
                popupActive: false,
                trashed: localStorage.getItem('deliverers') === 'true'
            };
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx;
                }
                return 0;
            },

            getTrashed() {
                console.log('test');
                return localStorage.getItem('deliverers');
            },
            queriedItems() {
                return this.$refs.table
                    ? this.$refs.table.queriedResults.length
                    : this.orders.length;
            },
            staffRoute() {
                if (this.$route.meta.staff) {
                    if (localStorage.getItem("stafftoken") !== null) {
                        return true;
                    }
                } else {
                    if (localStorage.getItem("stafftoken") !== null) {
                        return true;
                    }
                    return false;
                }
            },
            activeOrderTitle: function () {
                if (this.activeOrder !== null) {
                    return "Bestelnummer #" + this.activeOrder.id;
                }
            },
            chipColor(value) {
                if (value === "active") return "success";
                else if (value === "blocked") return "danger";
                else if (value === "deactivated") return "warning";
                else return "primary";
            },
        },
        watch: {
            $route(to, from) {
                // react to route changes...
                if (to.params.slug !== null) {
                    this.getOrders();
                }
            },
            trashed() {
                console.log('updaeting trash')
                if (this.trashed === false) {
                    this.getDeliverers();
                    localStorage.setItem('deliverers', false);
                } else {
                    this.getTrashedDeliverers();
                    localStorage.setItem('deliverers', true);
                }
            }
        },
        methods: {
            address(deliverer) {
                return deliverer.address.street !== null ? deliverer.address.street + " " + deliverer.address.housenumber + ", " + deliverer.address.postal_code + " " + deliverer.address.city : deliverer.address;
            },
            getDeliverers() {
                this.$http.get('https://api.staging.hebtrek.nl/staff/deliverers')
                    .then((response) => {
                        this.deliverers = response.data;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
            getTrashedDeliverers() {
                this.$http.get('https://staffapi.staging.hebtrek.nl/v1/deliverers/trashed')
                    .then((response) => {
                        this.deliverers = response.data;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
            closeEverything() {
                this.$events.fire('close-deliverer-modal');
            },
            saveDeliverer(deliverer) {
                let data = {
                    _method: "PUT",
                    id: deliverer.id,
                    office: deliverer.office,
                    area: deliverer.area,
                    firstname: deliverer.firstname,
                    insertion: deliverer.insertion,
                    lastname: deliverer.lastname,
                    birth_date: deliverer.birth_date,
                    address: deliverer.address,
                    phone_number: deliverer.phone_number,
                    email: deliverer.email,
                };
                this.$http
                    .post('/v1/deliverer/update', data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then(() => {
                        this.popupActive = false;
                        this.$vs.notify({
                            title: 'Gelukt!',
                            text: "Gegevens voor " + deliverer.firstname + " zijn opgeslagen!",
                            color: 'green',
                            position: 'top-center',
                        });
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
            addNewData() {
                this.$events.fire('create-deliverer-modal');
            },
            openPopup(deliverer) {
                this.$events.fire('open-deliverer-modal', deliverer);
            },
            openSmsPopup(deliverer) {
                this.$events.fire('open-sms-modal', deliverer);
            },
            openNotificationPopup(deliverer) {
                this.$events.fire('open-notification-modal', deliverer);
            },
            toggleDataSidebar(val = false) {
                this.addNewDataSidebar = val;
            },
            updateList() {
                this.getDeliverers();
            }
        },
        created() {
        },
        mounted() {
            this.isMounted = true;
            this.$events.listen('refresh-deliverers', () => {
                this.getDeliverers();
                console.log("refreshing deliverers");
            });
            if (this.trashed === true) {
                this.getTrashedDeliverers();
            } else {
                this.getDeliverers();
            }
        },
    };
</script>

<style lang="scss">
    #data-list-thumb-view {
        .vs-con-table {
            .order-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

                    td {
                        padding: 10px;

                        &:first-child {
                            border-top-left-radius: 0.5rem;
                            border-bottom-left-radius: 0.5rem;
                        }

                        &:last-child {
                            border-top-right-radius: 0.5rem;
                            border-bottom-right-radius: 0.5rem;
                        }

                        &.img-container {
                            width: 1rem;
                            background: #fff;

                            span {
                                display: flex;
                                justify-content: flex-start;
                            }

                            .order-img {
                                max-height: 100px;
                                max-width: 100px;
                            }
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
